import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type LocaleState = {
  /** Langue choisie explicitement par l'utilisateur ; `null` tant qu'il n'a rien choisi. */
  locale: string | null
  setLocale: (locale: string) => void
}

/**
 * v0 → v1 (#146) : `null` signifie désormais « pas de choix », et la langue de
 * l'organisation s'applique. La v0 enregistrait `en` par défaut, indiscernable
 * d'un vrai choix : on l'oublie. Un `fr`, lui, ne pouvait venir que de
 * l'utilisateur : on le garde.
 */
export function migrateLocale(persisted: unknown): { locale: string | null } {
  const locale = (persisted as { locale?: unknown } | null)?.locale
  return { locale: locale === 'fr' ? 'fr' : null }
}

const useLanguageStore = create<LocaleState>()(
  persist(
    set => ({
      locale: null,
      setLocale: (locale: string) => set({ locale }),
    }),
    {
      name: 'locale-storage',
      version: 1,
      migrate: migrateLocale,
    },
  ),
)

export default useLanguageStore
